/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-08-29 09:07:37
 * @LastEditTime : 2023-09-19 13:18:00
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_change\src\api\GHnumber\demand.js
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/dataCollection/supplierPlanDetail/QueryPage'
export const Download = '/icps/system/sign/dataCollection/supplierPlanDetail/exportList'
export function getListByraw(data) {
  return request({
    url: '/icps/system/sign/dataCollection/contract/getListByraw',
    method: 'post',
    data
  })
}
export function carRedeploy(data) {
  return request({
    url: '/icps/system/sign/dataCollection/supplierPlanDetail/carRedeploy',
    method: 'post',
    data
  })
}
export function saveOrUpdate1(data) {
  return request({
    url: '/icps/system/sign/dataCollection/supplierPlan/saveOrUpdate',
    method: 'post',
    data
  })
}
export function QueryPage2(data) {
  return request({
    url: '/icps/system/sign/dataCollection/consignment/QueryPage',
    method: 'post',
    data
  })
}
/*异常申请*/
export function applyException(data) {
  return request({
    url: '/icps/system/sign/dataCollection/consignment/applyException',
    method: 'post',
    data
  })
}
/*异常评价*/
export function evaluateException(data) {
  return request({
    url: '/icps/system/sign/dataCollection/consignment/evaluateException',
    method: 'post',
    data
  })
}
/*获取车辆合同*/
export function getContractCarByCondition(data) {
  return request({
    url: '/icps/system/sign/dataCollection/contract/getContractCarByCondition',
    method: 'post',
    data
  })
}
/*保存实际交货*/
export function saveDelivery(data) {
  return request({
    url: '/icps/system/sign/dataCollection/consignment/save',
    method: 'post',
    data
  })
}
